import { graphql, useStaticQuery } from "gatsby";
import { getStoryblokLanguage } from "../../config/storyblok-config";
import { fixStoryblokPath } from "../utils/storyblok/urls";

type Paths = {
	storesPath: string;
	orderConfirmationPath: string;
	searchPath: string;
	cartPath: string;
	checkoutPath: string;
	warrantyPath: string | undefined;
};

const query = graphql`
	query UseTranslatedPaths {
		checkout: storyblokEntry(field_component: { eq: "checkout_page" }) {
			lang
			full_slug
		}
		stores: storyblokEntry(field_component: { eq: "stores_page" }) {
			lang
			full_slug
		}
		order_confirmation: storyblokEntry(
			field_component: { eq: "order_confirmation_page" }
		) {
			lang
			full_slug
		}
		cart: storyblokEntry(field_component: { eq: "cart_page" }) {
			lang
			full_slug
		}
		search: storyblokEntry(field_component: { eq: "search_page" }) {
			lang
			full_slug
		}
		warranty_page: storyblokEntry(slug: { eq: "general-warranty-policies" }) {
			lang
			full_slug
		}
	}
`;

export const useTranslatedPaths = (): Paths => {
	const translatedPaths = Object.fromEntries(
		Object.entries(
			useStaticQuery<Queries.UseTranslatedPathsQuery>(query),
		).filter(([, value]) => value && value.lang === getStoryblokLanguage()),
	);

	return {
		storesPath: fixStoryblokPath(
			translatedPaths.stores?.full_slug ?? "/stores",
		),
		searchPath: fixStoryblokPath(
			translatedPaths.search?.full_slug ?? "/search",
		),
		checkoutPath: fixStoryblokPath(
			translatedPaths.checkout?.full_slug ?? "/checkout",
		),
		cartPath: fixStoryblokPath(translatedPaths.cart?.full_slug ?? "/cart"),
		orderConfirmationPath: fixStoryblokPath(
			translatedPaths.order_confirmation?.full_slug ?? "/order-confirmation",
		),
		warrantyPath: translatedPaths.warranty_page?.full_slug
			? fixStoryblokPath(translatedPaths.warranty_page.full_slug)
			: undefined,
	};
};
